<span class="cursor-icon" (click)="openModal()">Issue manual adjustment</span>
